import { render } from "./BetAmount.vue?vue&type=template&id=4d051956"
import script from "./BetAmount.vue?vue&type=script&lang=js"
export * from "./BetAmount.vue?vue&type=script&lang=js"

import "./BetAmount.vue?vue&type=style&index=0&id=4d051956&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__